import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlusCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { btnPrimary, PageHead } from "./ui";

const Stat = ({ label, value, testId, to }) => (
  <Link to={to} className="bg-white/60 border border-[#D5B98C]/50 p-5 hover:border-[#39251D] transition-colors">
    <div className="text-[11px] uppercase tracking-[0.2em] text-[#956842]">{label}</div>
    <div data-testid={testId} className="font-serif text-4xl sm:text-5xl text-[#39251D] mt-2">{value ?? "—"}</div>
  </Link>
);

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  const [moves, setMoves] = useState([]);
  const { user } = useAuth();
  useEffect(() => {
    api.get("/admin/stats").then((r) => setS(r.data));
    api.get("/admin/movements", { params: { limit: 8 } }).then((r) => setMoves(r.data));
  }, []);
  return (
    <div data-testid="admin-dashboard">
      <PageHead title={`Buongiorno, ${user.name}`} subtitle="Panoramica BDC-Boutique">
        <Link to="/admin/prodotti/nuovo" data-testid="dashboard-new-product" className={btnPrimary}><PlusCircle className="w-4 h-4" /> Nuovo prodotto</Link>
      </PageHead>
      <div className="grid grid-cols-2 xl:grid-cols-6 gap-3 sm:gap-4">
        <Stat label="Prodotti" value={s?.products} testId="admin-stat-products" to="/admin/prodotti" />
        <Stat label="Pubblicati" value={s?.published} testId="admin-stat-published" to="/admin/prodotti?status=published" />
        <Stat label="Bozze" value={s?.drafts} testId="admin-stat-drafts" to="/admin/prodotti?status=draft" />
        <Stat label="Pezzi unici" value={s?.unique_pieces} testId="admin-stat-unique" to="/admin/prodotti?stock=unique" />
        <Stat label="Esauriti" value={s?.out_of_stock} testId="admin-stat-out-of-stock" to="/admin/prodotti?stock=out" />
        <Stat label="Categorie" value={s?.categories} testId="admin-stat-categories" to="/admin/categorie" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4 mt-4" data-testid="dashboard-orders">
        <Stat label="In attesa di pagamento" value={s?.orders_pending} testId="admin-stat-orders-pending" to="/admin/ordini?status=in_attesa_pagamento" />
        <Stat label="Bonifici scaduti" value={s?.orders_overdue} testId="admin-stat-orders-overdue" to="/admin/ordini?overdue=1" />
        <Stat label="Da spedire" value={s?.orders_to_ship} testId="admin-stat-orders-to-ship" to="/admin/ordini?status=pagato" />
      </div>
      <div className="mt-8 bg-white/60 border border-[#D5B98C]/50 p-5" data-testid="dashboard-movements">
        <h2 className="font-serif text-2xl text-[#39251D] mb-4">Ultimi movimenti di magazzino</h2>
        {moves.length === 0 && <p className="text-sm text-[#242321]/60">Nessun movimento registrato.</p>}
        <ul className="divide-y divide-[#D5B98C]/40 text-sm">
          {moves.map((m) => (
            <li key={m.id} className="py-2.5 flex flex-wrap justify-between gap-2">
              <span><span className="font-medium">{m.sku}</span> · {m.type} {m.delta > 0 ? `+${m.delta}` : m.delta}</span>
              <span className="text-xs text-[#242321]/55">{new Date(m.at).toLocaleString("it-IT")} · {m.user_email}</span>
            </li>
          ))}
        </ul>
      </div>
      {user.role === "titolare" && <p className="mt-6 text-xs text-[#242321]/55">Prima dell'apertura controlla la <Link to="/admin/pre-lancio" data-testid="dashboard-prelaunch-link" className="underline">Verifica pre-lancio</Link>.</p>}
    </div>
  );
}
